<template>
    <select ref="selectElement" class="form-control bootstrap-select"></select>
</template>

<script setup lang="ts">
    import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
    import { type IOptionNameFormatter, type ISortBy, Select } from "@/portal/formControls/Select";
    import { onMounted, ref } from "vue";

    const isInitialized = ref<boolean>(false);
    const selectedValue = defineModel<string | undefined>({
        required: true,
    });

    const props = defineProps<{
        dataSource: IDataSource<any>;
        formatter?: IOptionNameFormatter<any>;
        lazyInit?: boolean;
        showAllText?: string;
        keyProp?: string;
        orderBy?: string;
        sortBy?: ISortBy<any>;
    }>();

    const selectElement = ref<HTMLElement | null>(null);
    let select: Select<object>;

    onMounted(() => {
        if (!props.dataSource)
            throw new Error("No Select data source provided! Please provide either dataSource object or enum!");

        select = Select.createFromSelectWithOptions<any>({
            $select: $(selectElement.value!),
            dataSource: props.dataSource,
            formatter: props.formatter,
            lazyInit: props.lazyInit,
            showAllText: props.showAllText,
            keyProp: props.keyProp,
            multiSelect: false,
            orderBy: props.orderBy,
            sortBy: props.sortBy,
        });

        select.fetchData(() => {
            select.onChange = () => {
                selectedValue.value = select.getValue();
            };

            if (selectedValue.value && select.getOptions().includes(selectedValue.value)) {
                select.setValue(selectedValue.value);
            }
            isInitialized.value = true;
        });
    });

    function setError(error: boolean) {
        select.setError(error);
    }

    defineExpose({
        setError,
    });
</script>
